import React from "react";
import Chart from "react-apexcharts";
import { COLOR_SIN_DATOS } from "./constants";
import { formatNumber, truncarNombre } from "./utils";

// Dona generica del dashboard (Ventas por Categoria / Estado de Cpe).
// props.datos: [{ nombre, total, porcentaje, color }]
// props.formatearValor: como se muestra cada total (moneda o cantidad).
export default function GraficoDona(props) {
    const datos = props.datos || [];
    const formatearValor = props.formatearValor || ((valor) => formatNumber(valor, 0));
    const total = datos.reduce((acumulado, item) => acumulado + (item.total || 0), 0);
    const sinDatos = datos.length === 0 || total <= 0;

    // Sin informacion no se deja el panel en blanco: se pinta un anillo gris
    // con el total en 0.
    const items = sinDatos
        ? [{ nombre: "Sin información", total: 0, porcentaje: 0, color: COLOR_SIN_DATOS }]
        : datos;
    const series = sinDatos ? [1] : items.map((item) => item.total);

    const describir = (item) => `${formatearValor(item.total)} (${formatNumber(item.porcentaje, 0)}%)`;
    // ApexCharts inserta la leyenda como innerHTML, por eso el <br/> corta
    // la linea antes del monto.
    const separador = props.leyendaEnLinea ? "&nbsp;&nbsp;&nbsp;" : "<br/>";

    const options = {
        chart: { type: "donut" },
        labels: items.map((item) => item.nombre),
        colors: items.map((item) => item.color),
        dataLabels: { enabled: false },
        stroke: { width: sinDatos ? 0 : 2 },
        states: {
            hover: { filter: { type: sinDatos ? "none" : "lighten" } },
            active: { filter: { type: "none" } },
        },
        legend: {
            position: "right",
            verticalAlign: "middle",
            fontSize: "13px",
            itemMargin: { vertical: 6 },
            formatter: (nombre, opts) => {
                const item = items[opts.seriesIndex] || { total: 0, porcentaje: 0 };
                return `${truncarNombre(nombre)}${separador}${describir(item)}`;
            },
        },
        plotOptions: {
            pie: {
                donut: {
                    size: "68%",
                    labels: {
                        show: true,
                        value: {
                            formatter: (valor) => (sinDatos ? formatearValor(0) : formatearValor(Number(valor))),
                        },
                        total: {
                            show: true,
                            showAlways: true,
                            label: "Total",
                            formatter: () => formatearValor(total),
                        },
                    },
                },
            },
        },
        // Los tooltips de dona no usan tooltip.x/tooltip.y.title (esos son
        // para charts de ejes); el contenido se arma a mano.
        tooltip: {
            enabled: !sinDatos,
            custom: ({ seriesIndex }) => {
                const item = items[seriesIndex] || { nombre: "", total: 0, porcentaje: 0 };
                return `
                    <div style="padding:8px 12px;">
                        <span style="color:${item.color};margin-right:6px;">●</span>
                        <strong>${truncarNombre(item.nombre)}</strong>: ${describir(item)}
                    </div>
                `;
            },
        },
        // Cuando el panel es angosto la leyenda a la derecha aprieta la
        // dona; ahi se pasa a leyenda inferior.
        responsive: [
            {
                breakpoint: props.breakpointLeyendaInferior || 576,
                options: {
                    legend: {
                        position: "bottom",
                        verticalAlign: "middle",
                        itemMargin: { horizontal: 8, vertical: 4 },
                    },
                },
            },
        ],
    };

    // react-apexcharts compara las options con JSON.stringify, que ignora las
    // funciones: si solo cambian los montos (formatters de leyenda y total),
    // no re-renderiza. La key obliga a remontar la dona cuando cambian los datos.
    const claveDatos = items.map((item) => `${item.nombre}:${item.total}`).join("|");

    return (
        <Chart
            key={`${props.claveFormato || ""}-${claveDatos}`}
            options={options}
            series={series}
            type="donut"
            width="100%"
            height={300}
        />
    );
}
